<template>
  <div>
    <v-app id="rozenbal" v-if="!this.$store.state.ficheAgent">
      <v-app-bar
        class="app-high-bar"
        app
        clipped-right
        light
        d-flex
        flex-row
        flat
        v-if="showMenuss"
      >
        <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
        <div class="logo"></div>
        <v-spacer></v-spacer>
        <v-toolbar-items class="d-flex flex-row top-right-menu">
          <!--  <v-text-field
            color="#fdc90b"
            append-icon="mdi-magnify"
            v-model="search"
            hide-details
            style="font-size:1.4rem; font-weight:200; max-width:370px;"
            outlined
            rounded
            dense
          ></v-text-field>-->
          <v-menu offset-y>
            <template v-slot:activator="{ on }" class="current-user">
              <v-img
                :src="user.co_id?$config.server_url+'/api/1.0/avatar/'+user.co_id+'/40/40?d='+user.updatedAt:'/img/default-profile.jpg'"
                height="40px"
                width="40px"
                class="rounded-image mt-3"
              ></v-img>
              <div class="d-flex withpointer" v-on="on">
                <div class="my-5 ml-5 mr-3" v-if="user">
                  {{user.co_firstname}}
                  <span style="font-weight:bold;">{{user.co_name}}</span>
                  <v-icon class="ml-2" style="color:#fdc90b;">mdi-settings</v-icon>
                </div>
              </div>
            </template>
            <v-list>
              <v-list-item @click="editMyAccount">
                <v-list-item-title>Mon compte</v-list-item-title>
              </v-list-item>
              <v-list-item @click="logout()">
                <v-list-item-title>Se déconnecter</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </v-toolbar-items>
      </v-app-bar>

      <v-navigation-drawer v-model="drawer" app dark width="200" v-if="showMenuss">
        <v-list-item-title class="text-center pt-3 pb-3 rozenbal">
          GENERATEUR
          <br />DE CATALOGUES
        </v-list-item-title>
        <v-list nav>
          <!-- <v-list-item link :class="{ active: $route.name=='home' }" @click="go('/home')">
            <v-list-item-icon>
              <icon class="icon-menu" name="home"></icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Accueil</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          -->
          <v-list-item
            v-if="$store.state.myrights.see_contacts"
            link
            :class="{ active: $route.path.indexOf('/contact') == 0 }"
            @click="go('/contacts')"
          >
            <v-list-item-icon>
              <icon class="icon-menu" name="user"></icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Utilisateurs</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item
            v-if="$store.state.myrights.import_matrice"
            link
            :class="{ active: $route.path.indexOf('/matrice') == 0 }"
            @click="go('/matrice')"
          >
            <v-list-item-icon>
              <icon class="icon-menu" name="rocket"></icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>La matrice</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item
            v-if="$store.state.myrights.see_catalogues"
            link
            :class="{ active: $route.path.indexOf('/catalogs') == 0 }"
            @click="go('/catalogs')"
          >
            <v-list-item-icon>
              <icon class="icon-menu" name="file-alt"></icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title class>Catalogues</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item
            link
            :class="{ active: $route.path.indexOf('/catalogs') == 0 }"
            @click="downloadAide()"
          >
            <v-list-item-icon>
              <icon class="icon-menu" name="question-circle"></icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title class>Aide</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <!-- <v-list-item link @click="logout()">
            <v-list-item-icon>
              <icon class="icon-menu" name="power-off"></icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Logout</v-list-item-title>
            </v-list-item-content>
          </v-list-item>-->
        </v-list>
      </v-navigation-drawer>

      <v-content>
        <div class="container-fluid px-5 py-3" ref="mainContainer" style="overflow:hidden;">
          <!-- <v-layout justify-center> -->
          <transition name="component-fade" mode="out-in">
            <router-view v-if="!search"></router-view>
            <research-view v-if="search" :researchVal="search" @deleteResearch="deleteResearch"></research-view>
          </transition>
          <!-- </v-layout> -->
        </div>
      </v-content>

      <contact-win-edit
        ref="ContactWinEdit"
        @contactWinEditSaved="contactWinEditSaved"
        @contactWinEditCanceled="contactWinEditCanceled"
        @contactWinEditDeleted="contactWinEditDeleted"
      ></contact-win-edit>
    </v-app>
  </div>
</template>

<script>
import "@fullcalendar/core/main.css";
import "@fullcalendar/daygrid/main.css";
import "@fullcalendar/timegrid/main.css";
import "@fullcalendar/list/main.css";
// import Vue from "vue";

export default {
  name: "App",
  components: {},
  data: () => ({
    showMenuss: true,
    drawer: true,
    // nbClientSuivi: 0,
    // nbBienSuivi: 0,
    // user: null,
    search: ""
    // itemsDropdownCR: []
  }),
  computed: {
    user() {
      return this.$store.state.user;
    }
  },
  async mounted() {
    // if (this.$route.query.action) {
    //   this.$refs.actionwinedit.open(this.$route.query.action);
    // }
    this.resizeMainContainer();
    window.addEventListener("resize", this.resizeMainContainer);

    // await this.$store.dispatch("load_dropdownMenuCR");
    // let itemsDropdownCR = this.$store.getters.get_compteRenduToDo;
    // if (itemsDropdownCR) this.itemsDropdownCR = itemsDropdownCR;
  },
  created() {
    // this.nbBienSuivi = this.$store.getters.get_nbbiensuivi;
    // this.nbClientSuivi = this.$store.getters.get_nbclientsuivi;
    // this.user = this.$store.state.user;
  },
  methods: {
    editMyAccount() {
      this.$refs.ContactWinEdit.open(this.$store.state.user.co_id);
    },
    contactWinEditSaved(co_id) {},
    contactWinEditCanceled(co_id) {},
    contactWinEditDeleted(co_id) {},

    downloadAide() {
      window.open(this.$config.server_url + "/api/1.0/matrice/help/", "_blank");
    },
    hideMenus() {
      this.showMenuss = false;
    },
    showMenus() {
      this.showMenuss = true;
    },
    // openWinActionCR(ac_id) {
    //   // console.log("ac_id", ac_id);
    //   if (this.$_.isPlainObject(ac_id)) ac_id = ac_id.ac_id;
    //   this.$refs.actionwinedit.open(ac_id);
    // },
    // actionWinEditSaved() {},
    resizeMainContainer() {
      if (!this.$refs.mainContainer) return;
      // if (this.$route.name == "login") {
      //   this.$refs.mainContainer.style.height = "100%";
      //   return;
      // }
      this.$refs.mainContainer.style.height =
        parseInt(window.innerHeight) - 64 + "px";
    },
    go(where) {
      // console.log("where", where);
      this.deleteResearch();
      this.$router.push(where);
    },
    deleteResearch() {
      this.search = "";
    },
    logout() {
      this.$store.commit("set_connexion", {
        token: null,
        refreshtoken: null,
        user: null,
        preferences: null
      });
      this.$router.push("/");
    },
    saveWinUser() {
      // console.warn("this.$store.state.user.co_name", this.$store.state.user);
      // this.$refs.modal1.close();
    },
    openWinUser() {
      this.$refs.modal1.open();
    },
    closeWinUser() {
      this.$refs.modal1.close();
    }
  }
};
</script>


<style scoped lang="scss">
@import "./sass/variables.scss";
.logo {
  background-image: url("./assets/logo-rozenbal.png");
  background-size: contain;
  background-position: center;
  width: 80px;
  height: 60px;
}
.navigation-drawer {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
}
.rozenbal {
  color: #fff;
  text-transform: uppercase;
}
.app-high-bar {
  border-bottom: solid 1px #dbdbdb; //$gris-clair
}
.current-user {
  border-left: solid 1px #dbdbdb; //$gris-clair
  padding-left: 20px;
}
.color-gray {
  color: gray;
}
.top-right-menu {
  align-items: center;
}
.theme--light.v-icon.mdi-magnify {
  color: #fdc90b !important;
}
.v-application--is-ltr .v-list-item__action:first-child,
.v-application--is-ltr .v-list-item__icon:first-child {
  margin-right: 15px;
}
</style>